import { useCallback, useState } from "react";

import { getShouldShowWriteReviewFormAfterOpenReviewsModal } from "@js/apps/reviews/slice";
import { useAppSelector } from "@js/hooks";

import { openWriteReviewSuccessModal } from "../write-review-success-modal";

type UseReviewModalProps = {
  closeReviewModal: () => void;
};
export const useReviewModal = ({ closeReviewModal }: UseReviewModalProps) => {
  const [showWriteReviewForm, setShowWriteReviewForm] = useState(false);
  const showWriteReviewFormAfterOpenReviewsModal = useAppSelector(
    getShouldShowWriteReviewFormAfterOpenReviewsModal,
  );

  const onSuccess = useCallback(() => {
    openWriteReviewSuccessModal();
    closeReviewModal();
  }, [closeReviewModal]);

  return {
    onSuccess,
    showWriteReviewFormAfterOpenReviewsModal,
    showWriteReviewForm,
    setShowWriteReviewForm,
  };
};
